module.exports = __webpack_public_path__ + "media/entities/6005-72fa6b61.png";